module.exports = __webpack_public_path__ + "static/media/campana_13.7c8263cd.mp3";